"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _DataList = require("./DataList");
var _styles = require("@mui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _styles2 = require("../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    dragHandle: {
      position: 'absolute',
      top: 0,
      left: 0,
      border: 'none',
      background: (0, _styles2.blend)(theme.palette.background["default"], theme.palette.action.active, theme.palette.action.hoverOpacity, 1),
      color: theme.palette.text.primary,
      width: '12px',
      cursor: 'move',
      height: '100%',
      '&:after': {
        content: '"::"',
        position: 'absolute',
        top: '50%',
        left: '2.71px',
        transform: 'translateY(-50%)',
        color: theme.palette.text.primary
      }
    },
    listItem: {
      boxShadow: function boxShadow(_ref) {
        var isDragging = _ref.isDragging;
        return isDragging ? theme.shadows[3] : null;
      },
      opacity: function opacity(_ref2) {
        var ghosted = _ref2.ghosted;
        return ghosted ? 0.7 : null;
      },
      color: theme.palette.text.primary,
      background: function background(_ref3) {
        var selected = _ref3.selected,
          reordered = _ref3.reordered;
        return selected || selected && reordered ? (0, _styles2.blend)(theme.palette.background["default"], theme.palette.secondary.main, theme.palette.action.focusOpacity, 1) : reordered ? (0, _styles2.blend)(theme.palette.background["default"], theme.palette.pending.main, theme.palette.action.focusOpacity, 1) : theme.palette.mode === 'light' ? theme.palette.background.paper : (0, _styles2.blend)(theme.palette.background["default"], theme.palette.action.active, theme.palette.action.focusOpacity, 1);
      }
    }
  };
});
function getStyle(provided, style) {
  if (!style) {
    return provided.draggableProps.style;
  }
  return _objectSpread(_objectSpread({}, provided.draggableProps.style), style);
}
var SortableDataListItem = function SortableDataListItem(_ref4) {
  var label = _ref4.label,
    secondaryLabel = _ref4.secondaryLabel,
    style = _ref4.style,
    className = _ref4.className,
    checkbox = _ref4.checkbox,
    selected = _ref4.selected,
    ghosted = _ref4.ghosted,
    reordered = _ref4.reordered,
    onClick = _ref4.onClick,
    secondaryAction = _ref4.secondaryAction,
    icon = _ref4.icon,
    divider = _ref4.divider,
    scrollDivider = _ref4.scrollDivider,
    actionCount = _ref4.actionCount,
    button = _ref4.button,
    disableGutters = _ref4.disableGutters,
    provided = _ref4.provided,
    snapshot = _ref4.snapshot,
    labelText = _ref4.labelText,
    secondaryLabelText = _ref4.secondaryLabelText,
    primaryTypographyProps = _ref4.primaryTypographyProps,
    secondaryActionProps = _ref4.secondaryActionProps;
  var isDragging = snapshot.isDragging;
  var classes = useStyles({
    selected: selected,
    ghosted: ghosted,
    reordered: reordered,
    isDragging: isDragging
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DataList.DataListItem, _objectSpread(_objectSpread({
    ref: provided.innerRef,
    className: (0, _clsx["default"])(className, classes.listItem),
    label: label,
    secondaryLabel: secondaryLabel,
    onClick: onClick,
    secondaryAction: secondaryAction,
    icon: icon,
    divider: divider,
    scrollDivider: scrollDivider,
    actionCount: actionCount,
    button: button,
    disableGutters: disableGutters,
    checkbox: checkbox,
    dragHandler: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({
      className: classes.dragHandle
    }, provided.dragHandleProps)),
    labelText: labelText,
    secondaryLabelText: secondaryLabelText
  }, provided.draggableProps), {}, {
    style: getStyle(provided, style),
    primaryTypographyProps: primaryTypographyProps,
    secondaryActionProps: secondaryActionProps
  }));
};
var _default = exports["default"] = SortableDataListItem;